module.exports = __webpack_public_path__ + "media/images/icons/tw-blue-color-9edeae0a14e0d5556c223e9c3fd137b1.svg";